export default __webpack_public_path__ + "static/media/iconGlyph.06373496.svg";